import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";

import BasePage from "@/components/BasePage.vue";
import {
  useConfigureParticipantId,
  useOpenBCIUtils,
  useWebsocketConnection,
} from "@/utils/hooks";
import { PhArrowRight } from "@phosphor-icons/vue";
import { ROUTES } from "@/utils/routes";
import OptimizeSignalAudioAndImpedancePanel from "@/components/audioAndImpedancePanel/OptimizeSignalAudioAndImpedancePanel.vue";

// ---- STATE ----

export default /*@__PURE__*/_defineComponent({
  __name: 'RecordingPage',
  setup(__props) {

useConfigureParticipantId();
useWebsocketConnection();
const {
  startRecording,
  stopRecording,
  isImpedanceCheckRunning,
  runImpedanceCheck,
  impedanceCheckChannel,
} = useOpenBCIUtils();

const progressValue = ref(0);
const bufferValue = ref(20);
const interval = ref(0);

const isAudioAndImpedancePanelOpen = ref(false);

// ---- CALLBACKS ----

const handleStopRecording = () => {
  isAudioAndImpedancePanelOpen.value = true;
};

const startBuffer = () => {
  clearInterval(interval.value);

  // Reset progress values
  progressValue.value = 0;
  bufferValue.value = 0;

  // Calculate the total time and interval duration
  const totalTime = 6000; // 5 seconds in milliseconds
  const steps = 100; // Number of steps to complete progress
  const intervalDuration = totalTime / steps;

  // Start the interval to update progress
  interval.value = setInterval(() => {
    // Increment progress values
    progressValue.value += 100 / steps;
    bufferValue.value += 100 / steps;

    // Check if progress has reached 100%
    if (progressValue.value >= 100) {
      // Ensure the progress bar is exactly at 100%
      progressValue.value = 100;
      bufferValue.value = 100;
      // Stop the interval after the delay
      clearInterval(interval.value);
    }
  }, intervalDuration);
};

// ---- LIFECYCLE HOOKS ----

onMounted(() => {
  setTimeout(() => {
    // Start the recording after a delay of 1 second
    startRecording();
  }, 1000);
});

watch(
  () => isImpedanceCheckRunning.value,
  (newValue) => {
    if (newValue) {
      startBuffer();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VCol = _resolveComponent("VCol")!

  return (_openBlock(), _createBlock(BasePage, { heading: "Recording" }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, {
        class: "flex-grow-0",
        style: {"position":"relative"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VCol, { style: {"z-index":"1"} }, {
            default: _withCtx(() => [
              _cache[1] || (_cache[1] = _createElementVNode("p", {
                class: "mb-5",
                style: {"color":"#737373","text-align":"center","font-weight":"500","font-size":"18px"}
              }, [
                _createTextVNode(" Recording in progress. You can now return to the experiment Tab."),
                _createElementVNode("br")
              ], -1)),
              _createVNode(_component_v_btn, {
                onClick: handleStopRecording,
                class: "mx-auto",
                "append-icon": _unref(PhArrowRight)
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" Stop Recording ")
                ])),
                _: 1
              }, 8, ["append-icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isAudioAndImpedancePanelOpen.value)
        ? (_openBlock(), _createBlock(OptimizeSignalAudioAndImpedancePanel, {
            key: 0,
            "next-route": _unref(ROUTES).FINISH,
            "impedance-check-channel": _unref(impedanceCheckChannel),
            "is-impedance-check-running": _unref(isImpedanceCheckRunning),
            "run-impedance-check": _unref(runImpedanceCheck),
            "stop-recording": _unref(stopRecording),
            "impedance-panel-description": `Resistance measurements for each electrode.<br />The recording will stop after this step.`
          }, null, 8, ["next-route", "impedance-check-channel", "is-impedance-check-running", "run-impedance-check", "stop-recording"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})